<template>
    <div class="box">

        <div class="handle-box-search">


            <el-row type="flex" justify="center" style="margin-bottom: 20px;display:flex;align-items:center">

                <span style="display: inline-block;width: 80px;text-align: right; margin-right: 5px;">密码:</span>
                <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>



            </el-row>




            <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...

            </div>

            <el-row type="flex" justify="center" v-else>

                <el-button type="primary" @click="toExport">导出司机钱包信息</el-button>


            </el-row>



        </div>




    </div>

</template>

<script>
    import axios from 'axios';
    import { config } from '@/utils/config.js'; //配置
    var _this;
    export default {

        data() {
            return {
                search_time: '',

                submit_data: {
                    page: 1,
                    export_password: ''
                },

                partnerList:[],

                excelData: [],

                excelHead: [],

                progress_show: false,
                progress_data: 0

            };
        },
        created() {
            _this = this;


        },

        methods: {

            toExport() {
                _this.submit_data.page = 1;

                _this.getExcelData();

            },

            getExcelData() {

                _this.$post(
                    "/order/getDriverwalletCSV",
                    _this.submit_data
                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/getDriverwalletCSV') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            console.log(res.data.list[i].order_code);
                            _this.excelData.push({
                                'id':res.data.list[i].id,
                                'bond':res.data.list[i].bond,
                                'balance':res.data.list[i].balance,
                                'cash':res.data.list[i].cash,
                                'frozen':res.data.list[i].frozen,
                                'cashing':res.data.list[i].cashing,
                                'insurance':res.data.list[i].insurance,
                                'connect':res.data.list[i].connect,
                                'name': res.data.list[i].name,
                                'phone': res.data.list[i].phone,
                                'status': res.data.list[i].status_name,
                               
                            

                            });


                        }



                        if (res.data.page * res.data.limit < res.data.count) {

                            _this.submit_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.submit_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;


                        }

                    } else {

                        _this.progress_show = false;
                        _this.progress_data = 0;

                    }



                }).catch((err) => {

                })

            },


            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['id','保证金','余额','提现','冻结','提现中','服务费','连单奖励','司机姓名','司机手机号','司机状态'];


                const filterVal = ['id','bond','balance','cash','frozen','cashing','insurance','connect','name','phone','status'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },




        }
    };
</script>

<style scoped>

</style>
